import { HSCAN_FRONT_URL, IAMPORT_CHANNEL_KEY } from '../env';
import { IamportPaymentResponse } from '../utils/iamport-types';

import { useUserState } from './accountHook';
import { useIamport } from './iamportHook';

export interface PayHookParams {
  paymentName: string;
  onSuccessPay: (merchantId: string) => void;
  /**
   * starts with /
   */
  mobileRedirectUrlPath: string;
}
export const usePay = ({
  paymentName,
  onSuccessPay,
  mobileRedirectUrlPath,
}: PayHookParams) => {
  const [user] = useUserState();
  const { isLoading, isPending, pay } = useIamport();
  const iamportPay = (merchantId: string, amount: number, taxFree?: number) => {
    pay({
      data: {
        merchant_uid: merchantId,
        channelKey: IAMPORT_CHANNEL_KEY,
        payment_method: 'card',
        name: paymentName,
        amount: amount,
        buyer_name: user?.name ?? '',
        buyer_tel: user?.telecom ?? '',
        buyer_email: user?.email ?? '',
        m_redirect_url: `${HSCAN_FRONT_URL}${mobileRedirectUrlPath}`,
        tax_free: taxFree,
      },
      callback: (resp: IamportPaymentResponse) => {
        if (resp.success) {
          onSuccessPay(merchantId);
        }
      },
    });
  };

  return {
    isLoading,
    isPending,
    pay: iamportPay,
  };
};
